const GATEWAY_COUNTRY_CODE_KEY = "gateway_country_code";

export function setStoredGatewayCountryCode(countryCode: string): void {
  localStorage.setItem(GATEWAY_COUNTRY_CODE_KEY, countryCode);
}

export function clearStoredGatewayCountryCode(): void {
  localStorage.removeItem(GATEWAY_COUNTRY_CODE_KEY);
}

export function getStoredGatewayCountryCode(): string {
  return localStorage.getItem(GATEWAY_COUNTRY_CODE_KEY) || "";
}
